import { Component, ChangeDetectionStrategy, OnInit, input } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { ClearingService } from '@uc/utilities';
import { RecommendedUniversity } from '@uc/web/shared/data-models';
import { Observable, tap } from 'rxjs';
import { getRecommendedUniversitiesSelector } from '../recommended-unis.utils';
import { AsyncPipe, NgClass } from '@angular/common';
import { RecommendedUniCardXsComponent } from './recommended-uni-card-xs/recommended-uni-card-xs.component';
import { RecommendedUniSingleComponent } from '../components/recommended-uni-single/recommended-uni-single.component';
import { Product } from '@uc/shared/data-models';
import { fetchRecommendedUniversities } from '../..';

@Component({
	selector: 'uc-recommended-unis-grid',
	templateUrl: './recommended-unis-grid.component.html',
	imports: [
		AsyncPipe,
		NgClass,
		RecommendedUniCardXsComponent,
		RecommendedUniSingleComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecommendedUnisGridComponent implements OnInit {
	product = input<Product>('undergraduate');
	componentName = input('UG Recommended Universities');
	topUnis: RecommendedUniversity[] = [];
	recommendedUniversities$!: Observable<RecommendedUniversity[] | undefined>;
	isClearing = this._clearingSrv.isClearing();

	constructor(
		private _store: Store,
		private _clearingSrv: ClearingService,
	) {}

	ngOnInit(): void {
		this._store.dispatch(fetchRecommendedUniversities());

		this.recommendedUniversities$ = this._store.pipe(
			select(getRecommendedUniversitiesSelector(this.product(), this.isClearing)),
			tap((unis) => {
				if (!unis) return;
				this.topUnis = unis.slice(0, 4);
			}),
		);
	}
}
